import { msg, Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { TFPageContent } from '@tf/shared';
import { Button, Center, Stack } from '@tf/ui';
import type React from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MarkdownPageIntro, useMenu } from '@/components/shared';
import { useDefinitions } from '@/core/providers';

import { usePageTitle } from '../../usePageTitle';

const defaultSuccessText = `
# Application sent

Thank you for submitting your application, it has been sent successfully. You'll be notified via email once we’ve reviewed your information.`;

export const SuccessRoute: React.FC = () => {
	const { _ } = useLingui();
	const { defs } = useDefinitions();
	const navigate = useNavigate();

	usePageTitle(_(msg({ id: 'successPage.title', message: 'Application sent' })));

	const { setMenuItems } = useMenu();
	useEffect(() => {
		setMenuItems([]);
	}, [setMenuItems]);

	return (
		<TFPageContent maw="50rem" m="0">
			<Stack align="center" mb="16px">
				<MarkdownPageIntro text={defs.customization.success_text ?? defaultSuccessText} />
			</Stack>
			<Center>
				<Button onClick={() => navigate('/')} bg="rgba(37, 99, 235, 0.08)" variant="light">
					<Trans id="successPage.goBackButton">Start another application</Trans>
				</Button>
			</Center>
		</TFPageContent>
	);
};
